import { render, staticRenderFns } from "./FE_companies.vue?vue&type=template&id=6cc719d1&scoped=true"
import script from "./FE_companies.vue?vue&type=script&lang=js"
export * from "./FE_companies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc719d1",
  null
  
)

export default component.exports